export default __webpack_public_path__ + "images/bb7cfafc90a8c84d1552a1364f4650b0.png";